import { Handshake, Mail } from "lucide-react";
import { useLang } from "../i18n";
import { Reveal, SectionShell } from "./Reveal";

export default function Collab() {
  const { t } = useLang();

  return (
    <SectionShell id="collaborazioni" testid="collab-section">
      <div className="mx-auto max-w-3xl text-center">
        <Reveal>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-slate-900">
            {t.collab.title}
          </h2>
        </Reveal>

        <Reveal delay={0.12} className="mt-8">
          <div className="rounded-3xl border border-slate-200 bg-white p-8 sm:p-10 shadow-sm text-left">
            <div className="flex items-center gap-3 text-sky-600">
              <Handshake size={24} />
            </div>
            <p className="mt-4 text-lg sm:text-xl text-slate-800 leading-relaxed">{t.collab.p1}</p>
            <p className="mt-4 text-slate-600 leading-relaxed">{t.collab.p2}</p>
            <a
              href={`mailto:${t.collab.email}`}
              data-testid="collab-email-btn"
              className="mt-6 inline-flex items-center gap-2 rounded-full bg-slate-900 px-6 py-3 text-sm font-semibold text-white transition-colors hover:bg-sky-600"
            >
              <Mail size={16} />
              {t.collab.cta} · {t.collab.email}
            </a>
          </div>
        </Reveal>
      </div>
    </SectionShell>
  );
}
